import * as React from "react";
import { css } from "emotion";
import Card from "./Card";

interface ImageCardProps {
  value: {
    src: string;
    caption: string;
  };
}
class ImageCard extends React.Component<ImageCardProps> {
  render() {
    return (
      <Card>
        <img
          src={this.props.value.src}
          className={css`
            width: 100%;
          `}
        />
        <div>{this.props.value.caption}</div>
      </Card>
    );
  }
}

export default ImageCard;
